import React, { useState, useEffect, useContext } from 'react';
import { RootStoreContext } from '../../stores/RootStore';
import { NotEnrolledList, NotEnrolledParam, NotEnrolledCallStatusUpdate } from '../../models/NotEnrolled';
import { ISelect } from '../../models/General';
import Select from "react-select";
import MaterialTable from "material-table";
import { TableIcons } from '../../utils/Icons';
import Alert from '@mui/material/Alert/Alert';
import { CircleSpinnerOverlay } from 'react-spinner-overlay'
import Modal from 'react-bootstrap/Modal';
import ExportButton from '../../utils/ExportButton';
import CallFeedbackForm from '../../utils/CallFeedbackForm';

const NotEnrolledListPage = () => {
    const rootStore = useContext(RootStoreContext);
    const { getNotEnrolledList, processUpdateCallStatus, getCallReason } = rootStore.notEnrolledStore;
    const { getInstitution, getSemesterWithNext } = rootStore.commonStore;
    const emplidVal = window.localStorage.getItem('emplid');

    const callStatusData = [
        { label: 'Not Called', value: '0' },
        { label: 'Called', value: '1' },
    ]

    // const baseCol =
    //     [
    //         {
    //             title: "Update",
    //             render: (rowData: any) => (
    //                 <div className="btn btn-primary"
    //                     onClick={() => {
    //                         if (btnUpdate) {
    //                             handleOpenModal(rowData)
    //                         }
    //                         else {
    //                             handleUpdateToNotCalled(rowData)
    //                         }

    //                     }}>Update {btnUpdateLabel}</div>
    //             )
    //         },
    //         { title: 'Name', field: 'NAME_DISPLAY' },
    //         { title: 'NIM', field: 'EMPLID' },
    //         { title: 'Class Of', field: 'CLASS_OF' },
    //         { title: 'Program', field: 'ACAD_PROG' },
    //         { title: "Email", field: "EMAIL_ADDR" },
    //         { title: "Phone", field: "PHONE1" },
    //     ]

    const [Enrolledlist, setEnrolledtList] = useState<NotEnrolledList[]>([])

    const [institution, setInstitution] = useState<ISelect[]>();
    const [institutionVal, setInstitutionVal] = useState<string>('');
    const [career] = useState<string>("UGRD");
    const [semester, setSemester] = useState<ISelect[]>();
    const [semesterVal, setSemesterVal] = useState<string>('');
    const [callStatus, setCallStatus] = useState<ISelect[]>(callStatusData); // untuk selectnya 
    const [callStatusVal, setCallStatusVal] = useState<string>('0'); // untuk value yang dikirim ke backend
    const [callStatusShownVal, setCallStatusShownVal] = useState([{ label: 'Not Called', value: '0' }]); // untuk value yang ditampilkan di user

    const [btnUpdate, setBtnUpdate] = useState(true)
    const [btnUpdateLabel, setBtnUpdateLabel] = useState('')

    const [status, setStatus] = useState("success")
    const [message, setMessage] = useState("")
    const [statusAlert, setStatusAlert] = useState(0)
    const [btnExport, setBtnExport] = useState(true)

    const [isLoading, setIsLoading] = useState(false)

    const [modalData, setModalData] = useState()
    const [IsModalOpen, setIsModalOpen] = useState(false);

    const never:
        | "always"
        | "onUpdate"
        | "onAdd"
        | "never" = "never";

    // const [columnsState, setColumnsState] = useState({
    //     columns: baseCol
    // })

    function handleInstitutionSelect(event: any) {
        setInstitutionVal(event.value);

        const semesterData = getSemesterWithNext(event.value, career);
        semesterData.then(function (result) {
            setSemester(result)
        })

    };

    function handleSemesterSelect(event: any) {
        setSemesterVal(event.value)
        setIsLoading(true);
        if (event.value !== "") {
            setBtnExport(false)
        }
    };

    function handleCallStatusSelect(event: any) {
        setCallStatusVal(event.value)
        setCallStatus(callStatusData)
        setCallStatusShownVal(event)
    }

    function handleUpdateForm(rowData: any, updateParam: any) {

        setIsLoading(true);
        const data: NotEnrolledCallStatusUpdate[] = [rowData];
        const newParam = new Array();
        // console.log(data)
        // console.log(list)
        var new_call_status = 1

        //jika call status filter adalah called, update menjadi not called
        if (callStatusVal !== '0') {
            new_call_status = 0
        }

        var param = {
            INSTITUTION: rowData.INSTITUTION,
            ACAD_CAREER: rowData.ACAD_CAREER,
            EMPLID: rowData.EMPLID,
            STRM: rowData.STRM,
            CREATED_BATCH: rowData.CREATED_BATCH,
            CALL_STATUS: new_call_status,
            CALL_BY: updateParam.callerName,
            REASON_ID: updateParam.callReasonId,
            REMARKS: updateParam.remarks,
            OPT_EMPLID: emplidVal
        }
        newParam.push(param)

        processUpdateCallStatus(newParam).then(function (response) {
            setStatusAlert(1)
            setMessage(response.message)
            setStatus(response.variant)
            setEnrolledtList(Enrolledlist.filter(x => !data.includes(x)))
            setIsLoading(false)
            closeModal()
        })
    }

    function handleOpenModal(rowData: any) {
        setIsModalOpen(true)
        setModalData(rowData)
    }

    function closeModal() {
        setIsModalOpen(false);
    }

    function handleUpdateToNotCalled(rowData: any) {
        handleUpdateForm(rowData, {})
    }

    const param: NotEnrolledParam = {
        INSTITUTION: String(institutionVal),
        STRM: String(semesterVal),
        CALL_STATUS: String(callStatusVal)
    };

    // const changeColFunction = () => {

    //     let data = new Array()

    //     if (callStatusVal == '0') {
    //         data = [
    //             { title: "Created Date", field: "CREATED_DATE", editable: 'never' as never },
    //         ]
    //     } else {
    //         data = [
    //             { title: "Call Time", field: "CALL_DTTM", editable: 'never' as never },
    //             { title: "Call By", field: "CALL_BY", editable: 'never' as never },
    //             { title: "Reason", field: "REASON_DESC", editable: 'never' as never },
    //             { title: "Remarks", field: "REMARKS", editable: 'never' as never },
    //         ]
    //     }

    //     let final = [...baseCol, ...data]
    //     setColumnsState({
    //         columns: final
    //     })
    // }

    function loadData() {
        if (callStatusVal == '0') {
            setBtnUpdate(true)
            setBtnUpdateLabel('')
        }
        else {
            setBtnUpdate(false)
            setBtnUpdateLabel('to Not Called')
        }

        getNotEnrolledList(param).then(function (response) {
            setEnrolledtList(response)
            setIsLoading(false)
        })
            .catch(() => {
                setStatusAlert(1)
                setMessage("Unable to fetch data")
                setStatus("danger")
                setIsLoading(false);
            });
    }

    useEffect(() => {
        if (institutionVal !== '' && semesterVal !== '' && callStatusVal !== '') {
            setIsLoading(true);

        }

        const institutionData = getInstitution(String(emplidVal));
        institutionData.then(function (result) {
            setInstitution(result);
        })

        loadData()

    }, [institutionVal, semesterVal, callStatusVal])

    return (
        <React.Fragment>
            {isLoading
                ? <CircleSpinnerOverlay zIndex={2000} loading={isLoading} color="#00FFFF" />
                : <></>
            }

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Not Enrolled</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <Modal show={IsModalOpen} onHide={closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Call Feedback</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <CallFeedbackForm rowData={modalData} handleUpdateForm={handleUpdateForm} getCallReason={getCallReason} ></CallFeedbackForm>
                        </Modal.Body>
                    </Modal>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Institution</label>
                                                <Select
                                                    name="institution"
                                                    placeholder="Choose Institution"
                                                    options={institution}
                                                    onChange={handleInstitutionSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label><span className='required-symbol'>*</span>Semester</label>
                                                <Select
                                                    name="semester"
                                                    placeholder="Choose Semester"
                                                    options={semester}
                                                    onChange={handleSemesterSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <Select
                                                    name="call-status"
                                                    placeholder="Choose Status"
                                                    options={callStatus}
                                                    value={callStatusShownVal}
                                                    onChange={handleCallStatusSelect}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-1">
                                            <ExportButton
                                                showBtnExport={btnExport}
                                                setIsLoading={setIsLoading}
                                                apiURL={`${process.env.REACT_APP_API_URL}/academic/enrollment/export-student/${institutionVal}/${semesterVal}/${callStatusVal}`}
                                                filename={"Student_Not_enrolled.xls"}
                                            ></ExportButton>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {
                            statusAlert == 1 ?
                                <>
                                    <Alert variant="filled" severity={'success' || status} onClose={() => { setStatusAlert(0) }}>{message}</Alert>
                                </> : <> </>
                        }
                        <br></br>
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Students List</h3>
                            </div>
                            <div className="card-body">
                                <MaterialTable
                                    title=""
                                    icons={TableIcons}
                                    columns={[
                                        {
                                            title: "Update",
                                            render: (rowData: any) => (
                                                <div className="btn btn-primary"
                                                    onClick={() => {
                                                        if (btnUpdate) {
                                                            handleOpenModal(rowData)
                                                        }
                                                        else {
                                                            handleUpdateToNotCalled(rowData)
                                                        }

                                                    }}>Update {btnUpdateLabel}</div>
                                            )
                                        },
                                        { title: 'Name', field: 'NAME_DISPLAY' },
                                        { title: 'NIM', field: 'EMPLID' },
                                        { title: 'Class Of', field: 'CLASS_OF' },
                                        { title: 'Program', field: 'ACAD_PROG' },
                                        { title: "Email", field: "EMAIL_ADDR" },
                                        { title: "Phone", field: "PHONE" },
                                        { title: "Created Date", field: "CREATED_DATE" },
                                        { title: "Call Time", field: "CALL_DTTM" },
                                        { title: "Call By", field: "CALL_BY" },
                                        { title: "Reason", field: "REASON_DESC" },
                                        { title: "Remarks", field: "REMARKS" },
                                    ]}
                                    data={Enrolledlist}
                                    options={{
                                        sorting: true,
                                        filtering: true,
                                        selection: false,
                                        showSelectAllCheckbox: false,
                                        emptyRowsWhenPaging: false,
                                        pageSize: 25,
                                        pageSizeOptions: [5, 10, 25, 50],
                                        loadingType: 'overlay',
                                        headerStyle: {
                                            fontWeight: 'bold',
                                        },
                                        rowStyle: rowData => ({
                                            backgroundColor: "#FFF",
                                            // backgroundColor: rowData.tableData.id % 2 === 0 ? "#EEE" : "#FFF",
                                        }),

                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default NotEnrolledListPage;
